<template>
  <div>
    <div class="field">
      <label class="label">{{ $t("send from") }}</label>
      <p class="control is-expanded has-icons-left">
        <input
          type="text"
          class="input"
          v-model="meta.send_from"
          placeholder="email@domain.com"
        />
        <span class="icon is-small is-left">
          <i class="fa fa-user"></i>
        </span>
      </p>
    </div>
    <div class="field">
      <label class="label">{{ $t("sender name") }}</label>
      <p class="control is-expanded has-icons-left">
        <input
          type="text"
          class="input"
          v-model="meta.sender_name"
          :placeholder="$t('your name')"
        />
        <span class="icon is-small is-left">
          <i class="fa fa-user"></i>
        </span>
      </p>
    </div>
    <div class="field">
      <label class="label">{{ $t("ip pool") }}</label>
      <p class="control is-expanded has-icons-left">
        <input
          type="text"
          class="input"
          v-model="meta.ip_pool"
          :placeholder="$t('pool.ip.com')"
        />
        <span class="icon is-small is-left">
          <i class="fa fa-user"></i>
        </span>
      </p>
    </div>
    <div class="field">
      <label class="label">{{ $t("api key") }}</label>
      <p class="control is-expanded has-icons-left">
        <input
          type="text"
          class="input"
          v-model="meta.api_key"
          placeholder="Abx52waDfGhjKlMn......"
        />
        <span class="icon is-small is-left">
          <i class="fa fa-key"></i>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      meta: {
        send_from: "",
        sender_name: "",
        ip_pool: "",
        api_key: "",
      },
    };
  },
  methods: {
    get_data() {
      return this.meta;
    },
    set_data(data) {
      this.meta = data;
    },
    clear() {
      this.meta = {
        send_from: "",
        sender_name: "",
        ip_pool: "",
        api_key: "",
      };
    },
  },
};
</script>
